import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const IconGraphic = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
     <path d="M4.83334 3.57485L7.16667 5.90819L10.4958 2.5791L11.8333 3.91669V0.416687H8.33333L9.67092 1.75427L7.16667 4.25852L4.83334 1.92519L0.337585 6.42094L1.16242 7.24577L4.83334 3.57485Z" />
    </SvgIcon>
  );
};

export default IconGraphic;
